/***
 * Model that represents Queue Notification
 */
import Backbone from 'backbone';

var NewsFeedStatus = Backbone.Model.extend({
    url: function() {
        return '/activitylist-service/activities/newsfeed/status?lastViewedTimeGMT=' + this.lastViewedTimeGMT;
    },

    backend: 'gcapi',

    initialize: function(args) {
        this.lastViewedTimeGMT = args.lastViewedTimeGMT;
    }
});

export default NewsFeedStatus;
